<template>
	<div>
		<BaseInput
			ref="BaseInput"
			v-model="model"
			:class="baseInputClass"
			:disabled="disabled"
			:error-message="errorMessage"
			:label="label"
			:maxlength="getMaxLength"
			:min-number="minNumber"
			:placeholder="getPlaceholder"
			:required="required"
			:sublabel="sublabel"
			:tab-index="tabIndex"
			:validation="validation"
			:label-class="labelClass"
			type="tel"
		>
			<currency-input
				v-model="model"
				:currency="optionalCurrency"
				:disabled="disabled"
				:maxlength="getMaxLength"
				:placeholder="getPlaceholder"
				:precision="precision"
				:tabindex="tabIndex"
				:value-range="valueRange"
				class="shadow-md base-input"
				type="text"
				@change="change"
			/>
			<template #bottom>
				<slot name="bottom" />
			</template>
		</BaseInput>
	</div>
</template>

<script>
import BaseInput from '@/components/forms/inputs/BaseInput';

export default {
	name: 'BaseInputNumber',
	components: { BaseInput },
	inheritAttrs: false,
	props: {
		label: {},
		required: {},
		value: {},
		valueRange: { default: undefined },
		errorMessage: {},
		maxLength: {},
		precision: { default: 0, type: Number },
		suffix: { default: '', type: String },
		minNumber: { default: null },
		sublabel: { default: null },
		validation: { default: null },
		tabIndex: { default: 0 },
		disabled: { type: Boolean, default: false },
		currency: { default: 'EUR' },
		placeholder: {},
		baseInputClass: { default: '' },
		filterOnly: { default: false },
		labelClass: { required: false}
	},
	computed: {
		getMaxLength() {
			let valueRangeMaxLength = this.valueRange?.max?.toString().length;
			if (valueRangeMaxLength && this.precision) {
				valueRangeMaxLength = valueRangeMaxLength + this.precision + 1;
			}

			return this.maxLength || valueRangeMaxLength || undefined;
		},
		getPlaceholder() {
			return this.placeholder || this.label;
		},
		optionalCurrency() {
			return this.isCurrency ? this.currency : null;
		},
		isCurrency() {
			return this.precision !== 0 || (this.currency?.prefix || this.currency?.suffix) !== undefined;
		},
		model: {
			get() {
				if (isNaN(this.value) || this.value === null) return null;
				return this.value / Math.pow(10, this.precision);
			},
			set(v) {
				if (!this.filterOnly) {
					this.$store.commit('setConfirmLeaving', this.$t('leave_page'));
				}
				this.$emit(
					'input',
					parseFloat(v)
						.toFixed(this.precision)
						.replaceAll('.', '')
						.replaceAll(',', ''),
				);
			},
		},
	},
	data() {
		return {
			isValid: true,
			money: {
				decimal: ',',
				thousands: '.',
				prefix: '',
				suffix: this.suffix,
				precision: this.precision,
				masked: false,
			},
		};
	},
	methods: {
		change($event) {
			this.$emit('change', $event);

			if (this.valueRange) {
				const isBiggerThanMax = $event > this.valueRange?.max;
				const isSmallerThanMin = $event < this.valueRange?.min;
				if (isSmallerThanMin || isBiggerThanMax) {
					let text = '';
					if (isSmallerThanMin) {
						text = this.$t('input_updated_to_min').toString();
					} else {
						text = this.$t('input_updated_to_max').toString();
					}

					this.$swal(this.$t('general.attention').toString(), text, 'warning');
				}
			}
		},
		validate() {
			this.isValid = this.$refs['BaseInput'].validate();
			if (this.required && isNaN(this.model)) {
				this.isValid = false;
				this.$refs['BaseInput'].isValid = false;
			}
			return this.isValid;
		},
	},
};
</script>

<style lang="sass" scoped>
.base-input
	height: 43px

.form-group label
	word-break: break-word
</style>
